export const filterRowsByPlayerName = (rows = [], searchTerm = "") => {
  const query = searchTerm.trim().toLowerCase();
  if (!query) return rows;
  return rows.filter((row) =>
    String(row.playerName || "").toLowerCase().includes(query)
  );
};
